export const NOTIFICATION_STATE = {
  SHOWN: 'SHOWN',
  READ: 'READ'
};